import { render, staticRenderFns } from "./documents.purchase.vue?vue&type=template&id=79862216"
import script from "./documents.purchase.vue?vue&type=script&lang=js"
export * from "./documents.purchase.vue?vue&type=script&lang=js"
import style0 from "./documents.purchase.vue?vue&type=style&index=0&id=79862216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports